export default [
	{
		path: "/admin/pros",
		exact: true,
		policy: "supportAdminAuth",
		component: "AdminProviders",
		mui: true,
	},
];
